export { default } from './PaymentsService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/payment/services/index.js